<template>
  <div>
    <div class="candidate-testing__question">
      <span>{{ index + 1 }}.</span>
      {{ question.question }}
      <div
        v-if="questionImage"
        class="candidate-testing__question_img-btn"
        @click="openDialogZoomImage()"
      >
        <img :src="require('../../assets/img/test/preview-img.svg')" alt="close">
      </div>
    </div>

    <div class="candidate-testing__answer-block">
      <div class="candidate-testing__answer">
        <template v-if="!answer">
          <div class="red-text">
            <span class="mr-1">x</span>
            {{ $t('noAnswer') }}
          </div>
          <div class="candidate-testing__answer_no-correct">
            {{ $t('correctAnswer') }}
            <span>«</span>
            {{ correctQuestionAnswers }}
            <span>»</span>
          </div>
        </template>
        <template v-else>
          <template v-if="question.type === testQuestionTypes.SELECT || question.type === testQuestionTypes.MULTISELECT">
            <template v-for="a in answers">
              <div class="red-text" :class="{ 'green-text' : a.isCorrect }">
                <span v-if="a.isCorrect" class="mr-1">✓</span>
                <span v-else class="mr-1">x</span>
                {{ a.answer }}
              </div>
            </template>
            <div v-if="!isCorrectAnswers" class="candidate-testing__answer_no-correct">
              {{ $t('correctAnswer') }}
              <span>«</span>
              {{ correctQuestionAnswers }}
              <span>»</span>
            </div>
          </template>
          <template v-else-if="question.type === testQuestionTypes.FREE">
            <div class="green-text">
              <span class="mr-1">✓</span>
              {{ answer.answer }}
            </div>
          </template>
          <template v-else>
            <template v-for="qAnswer in questionAnswers">
              <div class="red-text" :class="{ 'green-text' : answer.answer === qAnswer.answer }">
                <span v-if="answer.answer === qAnswer.answer" class="mr-1">✓</span>
                <span v-else class="mr-1">x</span>
                {{ answer.answer }}
              </div>
              <template v-if="answer.answer !== qAnswer.answer">
                <div v-if="qAnswer.isCorrect" class="candidate-testing__answer_no-correct">
                  {{ $t('correctAnswer') }} «{{ qAnswer.answer }}»
                </div>
              </template>
            </template>
          </template>
        </template>
      </div>
    </div>
    <VDialog
      v-model="dialogZoomImage"
      width="675"
      :retain-focus="false"
      overlay-color="black"
      overlay-opacity="0.1"
      content-class="elevation-0"
    >
      <div class="candidate-testing__dialog-img-content">
        <img v-if="questionImage" :src="questionImage" class="question-image">
        <VBtn
          icon
          small
          class="close-button"
          @click="closeDialogZoomImage()"
        >
          <img :src="require('../../assets/img/test/close.svg')" alt="close">
        </VBtn>
      </div>
    </VDialog>
  </div>
</template>

<script>
import {
  computed, ref, toRefs,
} from '@vue/composition-api';
import { testQuestionTypes } from '@/enums';

export default {
  name: 'CandidateTestResultQuestion',
  props: {
    question: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { question } = toRefs(props);

    const dialogZoomImage = ref(false);
    const answer = computed(() => question.value?.candidateAnswer);
    const questionAnswers = computed(() => question.value?.answers);
    const questionImage = computed(() => question.value?.image?.url);

    function closeDialogZoomImage() {
      dialogZoomImage.value = false;
    }

    function openDialogZoomImage() {
      dialogZoomImage.value = true;
    }

    const answers = computed(() => {
      const array = answer.value?.answer.split(';');
      const answersArray = [];
      question.value.answers.forEach((a) => {
        if (array.includes(String(a.id))) {
          answersArray.push(a);
        }
      });
      return answersArray;
    });

    const isCorrectAnswers = computed(() => {
      let correct = true;
      const allCorrectId = question.value.answers
        .filter(a => a.isCorrect)
        .map(a => a.id);

      const ans = answer.value.answer.split(';').map(Number);
      ans.forEach((a) => {
        if (!allCorrectId.includes(a)) {
          correct = false;
        }
      });

      return allCorrectId.length === ans.length && correct;
    });

    const correctQuestionAnswers = computed(() => question.value.answers.map((a) => {
      if (!a.isCorrect) {
        return;
      }

      return a.answer;
    }).filter(item => item !== undefined).join(', '));

    return {
      dialogZoomImage,
      questionAnswers,
      questionImage,
      closeDialogZoomImage,
      openDialogZoomImage,
      testQuestionTypes,
      answers,
      isCorrectAnswers,
      correctQuestionAnswers,
      answer,
    };
  },
};
</script>

<style lang="scss" scoped>
.candidate-testing {
  padding: 16px;

  &__header {
    display: flex;
    font-size: 14px;
    line-height: 16.8px;
    font-weight: 400;
    margin-bottom: 5px;
    @media screen and (max-width: 428px) {
      justify-content: space-between;
    }
  }

  &__info {
    color: #929292;
    font-size: 14px;
    line-height: 16.8px;
    display: flex;
    @media screen and (max-width: 1024px) {
      flex-direction: column;
      gap: 3px;
    }

    &_time {
      margin-right: 20px;
      @media screen and (max-width: 599px) {
        margin-right: 0;
      }
      @media screen and (max-width: 428px) {
        display: flex;
        justify-content: space-between;
      }
    }
    &_points {
      display: flex;
      div {
        margin-right: 20px;
        @media screen and (max-width: 428px) {
          display: flex;
          justify-content: space-between;
          margin-right: 0;
        }
      }
      @media screen and (max-width: 428px) {
        flex-direction: column;
      }
    }
  }

  &__question {
    font-size: 14px;
    line-height: 20px;
    &_img-btn {
      display: inline-block;
      cursor: pointer;
      margin-left: 3px;
    }
  }

  &__answer-block {
    margin-top: 7px;
  }

  &__answer {
    font-size: 14px;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    &_no-correct {
      color: #929292;
      @media screen and (max-width: 599px) {
        margin-left: 0;
      }
    }
  }

  &__dialog-img-content {
    position: relative;
    padding: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 599px) {
      padding: 0;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
}

.question-image {
  background-color: #fff;
  max-height: 400px;
  max-width: 100%;
  @media screen and (max-width: 599px) {
    max-height: 550px;
  }
}

.red-text {
  color: red;
}
.green-text {
  color: #1FC57F;
}

.close-button {
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>

<i18n locale="en" lang="yaml">
test: test
passed: passed
notPassed: not passed
explanation: Explanation
cutoff: Сutoff
noAnswer: There is no answer
timeSpent: Time elapsed
correctAnswer: correct answer
pointsScored: Points earned
outOf: out of
passing: Passing
</i18n>

<i18n locale="ru" lang="yaml">
test: тест
passed: пройден
notPassed: не пройден
explanation: Отсекающий
cutoff: Уточняющий
noAnswer: Нет ответа
timeSpent: Затрачено времени
correctAnswer: правильный ответ
pointsScored: Набрано баллов
outOf: из
passing: Проходной
</i18n>
